import { render, staticRenderFns } from "./users-management-full-page.vue?vue&type=template&id=a573b6c4"
import script from "./users-management-full-page.vue?vue&type=script&lang=js"
export * from "./users-management-full-page.vue?vue&type=script&lang=js"
import style0 from "./users-management-full-page.vue?vue&type=style&index=0&id=a573b6c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports